module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Light.ae6f8e02.woff2";